<template>
  <router-link :to="{ name: 'University', params: { slug: uni.slug }}" @click.native="goPage(uni)" class="info-card">
    <div class="info-card__top">
      <img :src="uni.logo ? uni.logo : require('@/assets/img/universite-logo-default.jpg')" alt="izmir ege üniversitesi yurt" class="info-card__logo">
      <h3 class="info-card__name">{{ uni.name }}</h3>
    </div>
    <!--<div class="info-card__bottom">-->
      <!--<div class="info-card__title">Kayıtlı Öğrenci Yurdu</div>-->
      <!--<div class="info-card__count">{{ uni.dorms[0].aggregate }}</div>-->
    <!--</div>-->
  </router-link>

</template>

<script>
export default {
  name: 'UniCard',
  props: {
    uni: Object
  },
  methods: {
    goPage(uni) {
           window.localStorage.setItem('faculty_id', '')
     window.localStorage.setItem('faculty_name', '')
     // let route = { name: 'University', params: { slug: uni.slug }}
     // this.$router.push(route)      
    }
  }  
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/components/info-card";
</style>
